import fetchFunc from './fetchFunc.js'

export const ConsultaTipoPagVendedora = ({DATAINIT, DATAFIM, CODIGOVEND, LOJAORIGEM})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaTipoPagVendedora',{DATAINIT, DATAFIM, CODIGOVEND, LOJAORIGEM})
export const ConsultaTipoPagVendedoraGeral = ({DATAINIT, DATAFIM, CODIGOVEND, LOJAORIGEM})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaTipoPagVendedoraGeral',{DATAINIT, DATAFIM, CODIGOVEND, LOJAORIGEM})
export const AlteraSenhaVendedora = ({LOGIN, NOVASENHA})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/AlteraSenhaVendedora',{LOGIN, NOVASENHA})

export const ConsultaEstoqueLogistica = ({CODEMP, AD_CODREV, AD_CODFORNE, AD_CODITEM, AD_PAGINA})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaEstoqueLogistica',{CODEMP, AD_CODREV, AD_CODFORNE, AD_CODITEM, AD_PAGINA})
export const ConsultaEstoqueLoja = ({CODEMP, AD_CODREV, AD_CODFORNE, AD_CODITEM, AD_PAGINA})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaEstoqueLoja',{CODEMP, AD_CODREV, AD_CODFORNE, AD_CODITEM, AD_PAGINA})
export const ConsultaColecoesRevistas = ()=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaColecoesRevistas',{})
export const ConsultaColecoesRevistasLog = ()=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaColecoesRevistasLog',{})
export const ConsultaMetaEscritorio = ({DATAINIT, DATAFIM})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaMetaEscritorio',{DATAINIT, DATAFIM})
export const ConsultaMetaEscritorioMensal = ()=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ConsultaMetaEscritorioMensal',{})

//FASHION START
export const ResetaSenhaRevendedora = ({cliecpfcnpj})=>fetchFunc.fetchPost('https://api.backsankhya.babita.com.br/ResetaSenhaRevendedora',{cliecpfcnpj})


const db = {
    ConsultaTipoPagVendedora,
    AlteraSenhaVendedora,
    ConsultaEstoqueLogistica,
    ConsultaColecoesRevistas,
    ConsultaColecoesRevistasLog,
    ConsultaMetaEscritorio,
    ConsultaMetaEscritorioMensal,
    ResetaSenhaRevendedora
}

export default db;


